import React, { createContext, useContext } from "react";
import AppLib from "../AppLib/AppLib";
const AppLibContext = createContext();

export const AppLibProvider = ({ children }) => {
  return (
    <AppLibContext.Provider value={AppLib}>{children}</AppLibContext.Provider>
  );
};

export const useAppLibs = () => useContext(AppLibContext);
